/**
 * i18n-fundering (react-i18next).
 *
 * Conventie: alle gebruiker-zichtbare UI-tekst loopt via t('sectie.sleutel').
 * Vertalingen staan in ./locales/<taal>.json — NL is de bron-/fallbacktaal, FR is
 * volledig (Ixina/Heytens hebben Franstalige klanten). Talen toevoegen = nieuw
 * JSON-bestand + registreren in `resources` hieronder.
 *
 * Taalkeuze-volgorde: localStorage('cbridge-lang') → browsertaal → 'nl'.
 * De test in ./__tests__/locales.test.ts bewaakt dat NL en FR identieke
 * sleutelsets hebben, zodat vertalingen niet stil uit elkaar lopen.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import nl from './locales/nl.json';
import fr from './locales/fr.json';
import en from './locales/en.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'nl', label: 'Nederlands' },
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
] as const;

export const resources = {
  nl: { translation: nl },
  fr: { translation: fr },
  en: { translation: en },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'nl',
    supportedLngs: SUPPORTED_LANGUAGES.map(l => l.code),
    interpolation: { escapeValue: false }, // React escapet zelf
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'cbridge-lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
